import Head from 'next/head';
import Link from 'next/link';
import { Container, Row, Col } from 'react-bootstrap';

const InternalServerError = () => {
  return (
    <>
      <Head>
        <title>Error | Nikon USA</title>
      </Head>
      <div className="error-page-main-content">
        <Container className="content-block">
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6} className="text-center">
              <div className="py-5">
                <h1 className="h1 mb-4">Something went wrong</h1>
                <p className="text-nikon-text-dark-grey mb-5">
                  We&apos;re working to fix this issue. Please try again in a few moments or return to our homepage.
                </p>
                <Link href="/" className="btn btn-yellow">
                  Go to homepage
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default InternalServerError;
